import React from "react";
import "./Activitse.css";
import LoadingSkeleton from "./LoadingSkeleton";
import QnaActivity from "./QnaActivity";

const ActivitiesContent4 = (props) => {
  const { openMessenger, setOpenMessenger, setEachChat } = props;
  return (
    <>
      <div className="row mt-3">
        {props.loader ? (
          props.event.map((event) => {

            return (
              <>
                <QnaActivity
                  event={event.qna}
                  singleEvent={event}
                  event_type="qna"
                  openMessenger={openMessenger}
                  setOpenMessenger={setOpenMessenger}
                  setEachChat={setEachChat}
                />
              </>
            );
          })
        ) : (
          <LoadingSkeleton />
        )}
      </div>
    </>
  );
};

export default ActivitiesContent4;
